import { ApiService } from './api';

export class AuthService {
    private apiService: ApiService;

    constructor(apiService: ApiService) {
        this.apiService = apiService;
    }

    async login(email: string, password: string): Promise<{ token: string; user: { email: string; name?: string } }> {
        const result = await this.apiService.login(email, password);
        this.apiService.setToken(result.token);
        return result;
    }

    logout(): void {
        this.apiService.clearToken();
    }

    isAuthenticated(): boolean {
        return !!localStorage.getItem('token');
    }

    getToken(): string | null {
        return localStorage.getItem('token');
    }
}
